"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
var react_router_dom_1 = require("react-router-dom");
var AxiosClient_1 = require("../utils/AxiosClient");
//  cart
var functions_1 = require("../interfaces/functions");
var react_hot_toast_1 = require("react-hot-toast");
// products cards
var material_1 = require("@mui/material");
// icons imports
var AddShoppingCartOutlined_1 = __importDefault(require("@mui/icons-material/AddShoppingCartOutlined"));
var PlaylistAddCheck_1 = __importDefault(require("@mui/icons-material/PlaylistAddCheck"));
// view one product
var ProductDetails_1 = __importDefault(require("../components/ProductDetails"));
function Results() {
    var _this = this;
    var location = (0, react_router_dom_1.useLocation)();
    var searchQuery = new URLSearchParams(location.search).get("searchproduct");
    var _a = (0, react_1.useState)([]), searchResults = _a[0], setSearchResults = _a[1];
    var _b = (0, react_1.useState)(true), searchInProgress = _b[0], setSearchInProgress = _b[1];
    var _c = (0, react_1.useState)(null), selectedProduct = _c[0], setSelectedProduct = _c[1];
    (0, react_1.useEffect)(function () {
        var fetchSearchResults = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, searchResultsData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setSearchInProgress(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, AxiosClient_1.AxiosClient.get("/products/search?q=".concat(searchQuery))];
                    case 2:
                        response = _a.sent();
                        console.log(response.data);
                        searchResultsData = response.data.products;
                        setSearchResults(searchResultsData);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setSearchInProgress(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchSearchResults();
    }, [searchQuery]);
    var handleViewClick = function (product) {
        setSelectedProduct(product);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hot_toast_1.Toaster, null),
        react_1.default.createElement(Navbar_1.default, { iconNumber: 1 }),
        react_1.default.createElement(material_1.Box, { sx: { p: 2 } },
            react_1.default.createElement(material_1.Typography, { variant: "h4", gutterBottom: true },
                "Search results for ",
                searchQuery),
            searchResults.length === 0 && (react_1.default.createElement(material_1.Typography, { variant: "body1" }, "No results found.")),
            searchResults.length > 0 && (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, sx: { justifyContent: "center" } },
                searchInProgress && react_1.default.createElement(material_1.CircularProgress, null),
                searchResults.map(function (product) { return (react_1.default.createElement(material_1.Grid, { item: true, key: product.ProductID, xs: 12, sm: 6, md: 4, lg: 3 },
                    react_1.default.createElement(material_1.Card, { sx: { height: "100%" } },
                        react_1.default.createElement(material_1.CardActionArea, { onClick: function () { return handleViewClick(product); } },
                            react_1.default.createElement(material_1.CardMedia, { component: "img", height: "140", image: product.pro_images.length > 0
                                    ? product.pro_images[0].ImagePath
                                    : "https://nayemdevs.com/wp-content/uploads/2020/03/default-product-image.png", alt: product.ProductName }),
                            react_1.default.createElement(material_1.CardContent, null,
                                react_1.default.createElement(material_1.Typography, { gutterBottom: true, variant: "h5", component: "div" }, product.ProductName),
                                react_1.default.createElement(material_1.Typography, { variant: "body1", gutterBottom: true },
                                    react_1.default.createElement("strong", null, "Price:"),
                                    " ",
                                    product.ProductPrice),
                                react_1.default.createElement(material_1.Typography, { variant: "body1", gutterBottom: true },
                                    "Description: ",
                                    product.ProductDesc))),
                        react_1.default.createElement(material_1.CardActions, { sx: { display: "flex", justifyContent: "space-between" } },
                            react_1.default.createElement(material_1.Tooltip, { title: "Add to cart" },
                                react_1.default.createElement(material_1.Button, { size: "small", color: "primary", onClick: function () { return (0, functions_1.AddToCart)(product.ProductID); } },
                                    react_1.default.createElement(AddShoppingCartOutlined_1.default, null))),
                            react_1.default.createElement(material_1.Tooltip, { title: "Add to wishlist" },
                                react_1.default.createElement(material_1.Button, { size: "small", color: "primary", onClick: function () { return (0, functions_1.AddtoWishlist)(product.ProductID); } },
                                    react_1.default.createElement(PlaylistAddCheck_1.default, null))))))); })))),
        selectedProduct && (react_1.default.createElement(ProductDetails_1.default, { product: selectedProduct, onClose: function () { return setSelectedProduct(null); } }))));
}
exports.default = Results;
